import React, {useState, useEffect, useContext, useRef} from 'react';
import CircularLoader from "../common/CircularLoader";
import axios from "../common/axios";

const DynamicContent = props => {
    const {url, hash, params, className, style = {}, entityId, updateHash = true, callback} = props;
    const [isLoading, setLoading] = useState(true);
    const [isError, setError] = useState(false);
    const [dynamicContent, setDynamicContent] = useState('');
    const divRef = useRef();

    const loadContent = (abortController) => {
        const locParams = {bodyOnly: true, ...params};

        setDynamicContent('');
        setLoading(true);
        axios.get(url, {params: locParams, signal:abortController.signal})
            .then(response => {
                try {
                    if(response.request.responseURL.indexOf(url) === -1) {
                        window.location = response.request.responseURL;
                    } else {
                        setDynamicContent(response.data);
                        //Replace if it is not in a React Component.
                        if (window.location.href.includes('.action') && updateHash) {
                            window.history.replaceState({}, '', url + (window.location.hash ? window.location.hash : ''));
                        }
                        setLoading(false);
                        setError(false);
                    }
                } catch (e) {
                    console.error('Error loading content', e);
                    setDynamicContent('');
                    setLoading(false);
                    setError(true);

                    if (typeof newrelic !== 'undefined') {
                        newrelic.noticeError('Content error: ' + e);
                    }
                }
            }).catch(function (e) {
                console.error('Error loading content', e);
                if (!e.name || e.name != 'CanceledError') {
                    setError(true);

                    if (typeof newrelic !== 'undefined') {
                        newrelic.noticeError('Content error: ' + e);
                    }
                }
            }).finally(()=>{
                abortController = null;
                setLoading(false);
            });
    }

    useEffect(() => {
        const abortController = new AbortController();
        if (url) {
            loadContent(abortController);
        }

        return(()=>{
          if(abortController){
              abortController.abort();
          }
        });
    }, [url,entityId,hash]);

    useEffect(() => {
        if (dynamicContent == undefined) {
            return;
        }

        if (!divRef.current) {
            return;
        }

        try {
            const htmlFragment = document.createRange().createContextualFragment(dynamicContent);
            divRef.current.replaceChildren(htmlFragment);

            if(dynamicContent) {
                if (callback && typeof callback === 'function') callback(divRef.current);
                $(divRef.current).reloadMathJax();
            }
        } catch (e) {
            console.error('Error loading content', e);
            setDynamicContent('');
            setLoading(false);
            setError(true);
            if (typeof newrelic !== 'undefined') {
                newrelic.noticeError('Content error: ' + e);
            }
        }
    }, [dynamicContent]);

    return (
        <>
            {isLoading && (
                <CircularLoader displayInElement={true} pageCentered={true}/>
            )}
            {isError && (
                <div className="ch-content-error">There was an error loading your content. Return to &nbsp;<a
                    href="/dashboard/loadActivityDashboard.action">Dashboard</a></div>
            )}
            <div className={"ch-dynamic-content" + (className ? ' ' + className : '')} style={style} ref={divRef}></div>
        </>
    );
}

export default DynamicContent;
